import { render, staticRenderFns } from "./SpeechRecognition.vue?vue&type=template&id=f5635096&scoped=true"
import script from "./SpeechRecognition.vue?vue&type=script&lang=js"
export * from "./SpeechRecognition.vue?vue&type=script&lang=js"
import style0 from "./SpeechRecognition.vue?vue&type=style&index=0&id=f5635096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5635096",
  null
  
)

export default component.exports